import { render, staticRenderFns } from "./Clamped.vue?vue&type=template&id=6b7111ee"
import script from "./Clamped.vue?vue&type=script&lang=ts"
export * from "./Clamped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports